import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useTrendingBooks(limit = 5) {
  return useQuery({
    queryKey: ['books', 'trending', limit],
    queryFn: () => libraryApi.listTrendingBooks(limit),
    staleTime: 5 * 60 * 1000,
  });
}
